import { cn } from '@/utils/styles';

interface LogoProps {
	className?: string;
}

export const LogoAnimated = ({ className }: LogoProps) => {
	return (
		<svg
			width="420"
			height="420"
			viewBox="0 0 420 420"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={cn('group/logo h-10 w-auto', className)}
		>
			<rect
				width="419.048"
				height="419.048"
				rx="34.9206"
				fill="#1D1F1F"
			/>
			<path
				d="M179.723 339.814H152.152V103.81L127.513 117.238L126.661 117.702L126.171 116.864L121.334 108.573L120.841 107.726L121.677 107.215L178.202 72.6693L179.723 71.7396V339.814Z"
				fill="#F0F0F0"
				className="transition-transform duration-150 ease-in-out group-hover/logo:-translate-x-8"
			/>
			<path
				d="M226.231 166.52C236.556 166.52 245.954 168.718 254.404 173.13C263.039 177.351 270.42 183.489 276.545 191.526C282.857 199.371 287.623 208.823 290.86 219.861C294.29 230.912 296 243.089 296 256.381C296 269.86 294.292 282.132 290.861 293.185L290.86 293.184C287.622 304.225 282.854 313.77 276.544 321.802L276.545 321.803C270.421 329.65 263.043 335.782 254.42 340.19L254.412 340.195C245.959 344.421 236.559 346.526 226.231 346.526C215.903 346.526 206.413 344.421 197.775 340.198L197.764 340.192L197.751 340.186C189.321 335.779 181.951 329.65 175.645 321.815L175.637 321.804L175.628 321.794C169.51 313.764 164.744 304.222 161.318 293.185L161.314 293.169C158.076 282.121 156.463 269.855 156.463 256.381C156.463 243.094 158.077 230.923 161.314 219.876L161.318 219.861C164.744 208.822 169.513 199.371 175.636 191.526L175.638 191.523C181.947 183.493 189.323 177.356 197.768 173.134C206.406 168.721 215.9 166.52 226.231 166.52ZM226.231 180.122C219.632 180.122 213.798 181.859 208.695 185.318L208.234 185.648C203.493 189.11 199.404 194.056 195.986 200.531C192.646 207.218 190.034 215.229 188.162 224.579L187.855 226.35C186.374 235.272 185.631 245.281 185.631 256.381C185.631 268.211 186.475 278.898 188.158 288.446C190.03 297.805 192.644 305.823 195.986 312.514C199.508 318.999 203.749 324.059 208.695 327.728C213.798 331.186 219.632 332.923 226.231 332.923C232.837 332.923 238.574 331.183 243.484 327.728C248.617 324.06 252.857 319.003 256.189 312.524L256.193 312.514H256.194C259.721 305.832 262.333 297.822 264.018 288.466L264.021 288.446C265.892 279.092 266.832 268.406 266.832 256.381C266.832 244.546 265.893 233.954 264.021 224.599L264.018 224.579C262.333 215.223 259.721 207.213 256.194 200.531L256.188 200.522L256.184 200.512C252.85 193.844 248.615 188.799 243.499 185.327L243.492 185.322L243.484 185.318C238.574 181.862 232.837 180.122 226.231 180.122Z"
				fill="#F0F0F0"
				className="transition-transform duration-150 ease-in-out group-hover/logo:translate-x-8"
			/>
		</svg>
	);
};
